import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  resizeImage,
  setUserArtDimensions,
  updateImageSize
} from "../../../../../../actions";
import { ResizableBox } from "react-resizable";
import Decimal from "decimal.js/decimal";

class UserArt extends React.Component {
  constructor(props) {
    super(props);

    // Take care of this.refs.image deprecation.
    this.image = null;
    this.setImageRef = (element) => {
      this.image = element;
    };

    const scale = new Decimal(this.props.previewScale).times(72).toNumber();
    this.state = {
      loaded: "",
      resizing: false,
      containerWidth: this.props.width * scale,
      containerHeight: this.props.height * scale
    };
  }

  componentDidMount() {
    // Set element to initially NOT loaded
    this.props.onVerifyElementLoaded(false);
  }

  handleOnLoad = () => {
    this.setState({ loaded: "loaded" });
    this.handleImageLoaded();
  };

  handleImageLoaded = () => {
    const clipartImage = new Image();
    clipartImage.src = this.props.url;

    const image = this.image,
      scale = new Decimal(this.props.previewScale).times(72).toNumber(),
      width = new Decimal(clipartImage.width).round().div(scale),
      height = new Decimal(clipartImage.height).round().div(scale);

    // Set dimensions first before marking as loaded
    this.props.setUserArtDimensions({
      index: this.props.index,
      layerId: this.props.layerId,
      width: width.toNumber(),
      height: height.toNumber()
    });

    // Set container size
    this.setContainerSize(clipartImage.width, clipartImage.height);

    // Mark as loaded only after dimensions are set
    this.props.onVerifyElementLoaded(true);
  };

  onResizeStart = (event, data) => {
    // event.stopPropagation()
    this.props.handleIsResizing(true);
    this.setState({
      resizing: true
    });
  };

  onResize = (event, { element, size }) => {
    this.setContainerSize(size.width, size.height);
  };

  onResizeStop = (event, { element, size }) => {
    const scale = new Decimal(this.props.previewScale).times(72),
      width = new Decimal(size.width).round().div(scale).toNumber(),
      height = new Decimal(size.height).round().div(scale).toNumber();

    this.props.resizeImage({
      index: this.props.index,
      layerId: this.props.layerId,
      width: width,
      height: height
    });

    this.setContainerSize(
      new Decimal(size.width).round().toNumber(),
      new Decimal(size.height).round().toNumber()
    );

    this.props.handleIsResizing(false);
    this.setState({
      resizing: false
    });

    let imageSize = width;
    this.props.updateImageSize({
      id: this.props.id,
      index: this.props.index,
      layerId: this.props.layerId,
      size: imageSize
    });
  };

  // Update the dimensions of the draggable container to match the image dimensions
  setContainerSize = (width, height) => {
    this.setState({
      containerWidth: width,
      containerHeight: height
    });
  };

  render() {
    const resizingState = this.props.resizing ? "resizing" : "",
      isSelected = this.props.isSelected ? "selected" : "",
      scale = new Decimal(this.props.previewScale).times(72).toString(),
      imageWidth = this.props.width,
      imageHeight = this.props.height;

    let isResizing = this.state.resizing ? "is-resizing" : "";

    const styles = {
      width: this.state.containerWidth + "px",
      height: this.state.containerHeight + "px"
    };

    const ratio = imageWidth / imageHeight,
      maxResizedHeight =
        scale * (this.props.layerHeight - this.props.topPosition),
      maxResizedWidth = maxResizedHeight * ratio,
      maxConstraints = [maxResizedWidth, maxResizedHeight];

    return (
      <div
        className={`resize-container ${resizingState} ${isSelected} ${isResizing}`}
        style={styles}
        // Backup container dimensions reset in case anything goes awry during resizing event
        //onClick={() => this.setContainerSize(this.props.width * scale, this.props.height * scale)}
      >
        {this.state.containerHeight && this.state.containerWidth ? (
          <ResizableBox
            width={this.state.containerWidth}
            height={this.state.containerHeight}
            maxConstraints={maxConstraints}
            onResizeStart={this.onResizeStart}
            onResize={this.onResize}
            onResizeStop={this.onResizeStop}
            // Add handles to box
            resizeHandles={["sw", "se", "nw", "ne", "w", "e", "n", "s"]}
            lockAspectRatio={true}
          />
        ) : null}
        <img
          className={`image-element__image ${this.state.loaded}`}
          src={this.props.url}
          alt=""
          onLoad={this.handleOnLoad}
          ref={this.setImageRef}
          width={this.state.containerWidth}
          height={this.state.containerHeight}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    previewScale: state.design.present.preview_scale
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resizeImage,
      setUserArtDimensions,
      updateImageSize
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserArt);
